const RESOURCE_IMG_HOST = `${window.api_endpoint}/resource/`
let resourceIdsInBody = [];

export default {
    methods: {
        sanitize(text) {
            const decode = (text) => $('<textarea />').html(text).text()
            return decode(decode(text))
        },

        parseEmailSpecialChars(html) {
            resourceIdsInBody = [];

            const specialChars = [
                "{link}",
                "{text_link}",
                "{plain_link}",
                "{name}",
                "{surname}",
                "{organisation}",
                "{login_code}",
            ]

            specialChars.map(char => {
                html = html.replaceAll(char, this.formatSpecialCharHtml(char))
            })

            const invalidSpecialChars = this.getInvalidSpecialChars(specialChars, html)
            for (const char of invalidSpecialChars) {
                const charIsResourceSrc = char.indexOf("cid") > -1
                html = charIsResourceSrc ?
                    this.handleResourceInBody(char, html) :
                    html.replaceAll(char, this.formatSpecialCharHtml(char, true))
            }

            return { html, resourceIdsInBody };
        },

        formatSpecialCharHtml(html, isInvalid = false) {
            return `<span class="${isInvalid ? 'invalid' : 'special'}-char">${html}</span>`
        },

        getInvalidSpecialChars(specialChars, str) {
            const results = [], regex = /{([^}]+)}/g;
            let text;

            while (text = regex.exec(str)) {
                const targetInCurlyBraces = `{${text[1]}}`
                if (specialChars.indexOf(targetInCurlyBraces) === -1) results.push(targetInCurlyBraces);
            }

            return results;
        },

        handleResourceInBody(char, html) {
            const resourceId = char.replace("{cid:", "").replace("}", "")
            resourceIdsInBody.push(resourceId)
            return html.replace(char, this.formatResourceIdSrc(resourceId))
        },

        formatResourceIdSrc(resourceId) {
            return `${RESOURCE_IMG_HOST}${resourceId}`
        },

        removeSpacesAroundAndInMiddle(text) {
            return text.trim().replace(/\s+/g, ' ')
        },
    }
}
